import { Pipe, PipeTransform } from '@angular/core';
import isEmpty from 'lodash-es/isEmpty';


import { isNullOrUndefined } from '@app/util/util';
import { getLuggageConditions, getLuggageMatchNumberByCondition } from '@shared/luggage/mappers/luggage-conditions.mapper';

@Pipe({
  name: 'luggage',
  standalone: false
})
export class LuggagePipe implements PipeTransform {

  transform(value: string): number {
    if (!isEmpty(value)) {
      const luggageConditions = getLuggageConditions(value);
      if (!isEmpty(luggageConditions[0])) {
        const luggageMatch = getLuggageMatchNumberByCondition(luggageConditions[0]);
        if (!isNullOrUndefined(luggageMatch) && !isEmpty(luggageMatch[0])) {
          const luggageNumber = luggageMatch[0];
          return parseInt(luggageNumber);
        } else return null;
      } else return null;
    } else return null;
  }

}
